import { gql } from '@apollo/client';

export const GET_IS_CONSOLE_USER_ACTIVE = gql`
  query isS1UserActive($console: String!) {
    isS1UserActive(managementConsoleUrl: $console)
  }
`;

export const GET_CONSOLE_ENDPOINT_DATA = gql`
  query S1Endpoint($console: String!, $agentUUID: String!) {
    s1Endpoint(agentUUID: $agentUUID, managementConsoleUrl: $console) {
      accountId
      accountName
      activeThreats
      agentVersion
      allowRemoteShell
      appsVulnerabilityStatus
      computerName
      coreCount
      cpuId
      cpuCount
      createdAt
      domain
      externalIp
      externalId
      firewallEnabled
      groupId
      groupName
      id
      inRemoteShellSession
      infected
      installerType
      isActive
      isDecommissioned
      isPendingUninstall
      isUninstalled
      isUpToDate
      lastActiveDate
      lastIpToMgmt
      lastLoggedInUserName
      licenseKey
      locationType
      machineType
      networkStatus
      osArch
      osName
      osRevision
      osType
      osStartTime
      rangerVersion
      registeredAt
      scanFinishedAt
      scanStatus
      scanStartedAt
      serialNumber
      siteId
      siteName
      storageName
      storageType
      totalMemory
      updatedAt
      uuid
      cloudProviders {
        name
        value {
          agentNamespace
          agentPodName
          awsRole
          awsSecurityGroups
          awsSubnetIds
          azureResourceGroup
          cloudAccount
          cloudImage
          cloudInstanceId
          cloudInstanceSize
          cloudLocation
          cloudNetwork
          cloudTags
          clusterName
          gcpServiceAccount
          kubernetesNodeLabels
          kubernetesNodeName
          kubernetesType
          kubernetesVersion
        }
      }
      tags {
        name
        value {
          allowEdit
          assignedAt
          assignedBy
          assignmentMethod
          description
          endpointsCurrentScope
          endpointsCurrentTotal
          id
          key
          scopeId
          scopeLevel
          type
          updatedAt
          updatedBy
          value
        }
      }
      networkInterfaces {
        gatewayIp
        gatewayMacAddress
        id
        inet
        inet6
        name
        physical
      }
      availableActions {
        data {
          name
          isDisabled
          disabledReason
        }
      }
      applications {
        data {
          installedDate
          name
          publisher
          size
          version
        }
      }
      tasks {
        data {
          accountId
          accountName
          agentComputerName
          agentId
          agentIsActive
          agentIsDecommissioned
          agentMachineType
          agentOsType
          agentUuid
          createdAt
          description
          detailedState
          groupId
          groupName
          id
          initiatedBy
          initiatedById
          parentTaskId
          scriptResultsSignature
          siteId
          siteName
          status
          statusDescription
          type
          updatedAt
        }
      }
    }
  }
`;
